<template>
  <div v-show="show" class="discussBox-container">
      <div class="bg"></div>
      <div class="discussBox-edit">
        <div class="title">
          <div class="left">讨论区</div>
          <div @click="close" class="close"></div>
        </div>
        <div class="tips">
          <i></i>
          <span>{{title}}</span>
        </div>
        <div ref="listP" class="list">
          <ul ref="listDom">
            <li v-for="item in list" :key="item.id">
              <div class="left">
                <img :src="item.avatar" alt="">
              </div>
              <div :class="{right: true, me: item.is_self == 1}">
                <p>{{item.content}}</p>
                <span>{{item.truename}} {{item.publish_time}}</span>
              </div>
            </li>
          </ul>
        </div>
        
        <div v-show="has_talkarea_edit_role" class="textarea">
          <input v-model="text" @keydown.enter="save" placeholder="Enter发送消息" maxlength="200" type="text">
          <div @click="save" class="btn">提交</div>
        </div>
      </div>
  </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import vClickOutside from "v-click-outside";

export default {
  name: 'confirm',
  directives: {
      clickOutside: vClickOutside.directive
  },
  data() {
    return {
      showEdit: false,
      editContent: '',
      foreman_view: '',
      text: '',
      list: [],
      show: true,
      showSelect: false,
      id: '',
      r: null,
      title: '',
      has_talkarea_edit_role: false
    }
  },
  methods: {
    scrollToBottom(){
      console.log(this.$refs.listDom.scrollHeight)
      this.$refs.listP.scrollTo({
          top: this.$refs.listDom.scrollHeight,
          behavior: 'smooth' // Enable smooth scrolling
      })
    },
    getList() {
      let info = {
        topic_id: this.id
      }
      common.myFetch(apis.newTopicListTalkarea,info).then(res => {
        this.list = res.list

        this.$nextTick(() => { 
          this.scrollToBottom()
        })
        
      })
    },
    open(c, r) {
      this.id = c.id;
      this.title = c.title;
      this.has_talkarea_edit_role = c.has_talkarea_edit_role
      this.getList()
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
      this.r(true)
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle()
      this.r(true)
      this.close()
    },
    beta() {
      this.config.beta.handle()
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    },
    save() {
      let info = {
        topic_id: this.id,
        content: this.text
      }
      common.myFetch(apis.newTopicReleaseTalkarea,info).then(res => {
        if(res){
          this.$toast(res);
          this.text = ''
          this.getList()
        }
      })
    },
    del(id) {
      let info = {
        topic_id: this.id,
        id: id
      }
      common.myFetch(apis.newTopicDeleteProgress,info).then(res => {
        if(res){
          this.$toast(res);
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .discussBox-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;

    .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);
    }

    .discussBox-edit {
      display: flex;
      flex-direction: column;
      width: 800px;
      height: 644px;
      background: #F9F9F9;
      box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
      border-radius: 4px;
      padding: 20px 30px;
      box-sizing: border-box;

      .title {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 16px;

        .left {
          font-weight: bold;
          font-size: 24px;
          color: #050F0F;
          line-height: 33px;
        }
        
        .close {
          display: block;
          width: 16px;
          height: 16px;
          background: url('../../assets/img/common/close.svg') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
        }
      }

      .tips {
        display: flex;
        align-items: center;
        width: 100%;
        height: 54px;
        background: rgba(65,180,140,0.1);
        border-radius: 12px;
        border: 1px solid #41B48C;
        box-sizing: border-box;
        padding: 0 20px;
        margin-bottom: 14px;

        i {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          background: url('./assets/xt.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
        }

        span {
          font-weight: 400;
          font-size: 16px;
          color: #050F0F;
          line-height: 22px;
        }
      }

      .list {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        min-height: 0;
        padding: 14px 0;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(185,195,195,0.5);
          border-radius: 2px;
        }

        ul {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        li {
          width: 100%;
          display: flex;
          align-items: flex-start;
          box-sizing: border-box;
          margin-bottom: 20px;

          .left {
            display: flex;
            margin-right: 14px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .right {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0;

            &.me {
              p {
                background: #D0ECE2;

                &::before {
                  position: absolute;
                  top: 16px;
                  left: -5px;
                  display: block;
                  content: '';
                  width: 5px;
                  height: 10px;
                  background: url('./assets/me.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }
            }

            p {
              position: relative;
              padding: 10px 20px 10px 14px;
              box-sizing: border-box;
              background: #E1E8EE;
              border-radius: 8px;
              margin-bottom: 4px;
              max-width: 100%;
              word-break: break-all;

              &::before {
                position: absolute;
                top: 16px;
                left: -5px;
                display: block;
                content: '';
                width: 5px;
                height: 10px;
                background: url('./assets/other.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }

            span {
              font-weight: bold;
              font-size: 13px;
              color: #B9C3C3;
              line-height: 18px;
            }
          }
        }
      }

      .textarea {
        display: flex;
        align-items: center;
        width: 100%;
        height: 52px;
        background: rgba(185,195,195,0.2);
        border-radius: 4px;
        padding: 0 14px;
        box-sizing: border-box;

        input {
          flex: 1;
          min-width: 0;
          height: 100%;
          background: transparent;
          outline: none;
          border: none;
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 68px;
          height: 32px;
          background: #41B48C;
          border-radius: 4px;
          font-weight: bold;
          font-size: 14px;
          color: #FFFFFF;
          user-select: none;
          cursor: pointer;
        }
      }
    }
}
</style>
